/**
 * User: liliana
 * Date: 6/2/14
 * Time: 4:33 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var SV = require('server-vars');
var breakpoints = require('../commonjs/cssVars').breakpoints;
var mobileCheck = require('bunsen/helpers/mobileCheck');
var Dfp = require('../../modules/commonjs/Dfp');

var $win = $(window);
var responsiveTargs;

module.exports = {
    init: function initNavDfp() {
        var dfp = new Dfp();
        responsiveTargs = breakpoints.integer;
        // add header shipping message copy from dfp
        $.onceEver('dfp:loaded', function () {
            var pageTarget = {
                pagetype : SV.settings.dfpPageType
            };

            if (!mobileCheck.iPhone()) {
                // FINDING-6231 : on iPad extra gray space appears after logging in
                //      changed breakpoint from 'tablet-portrait' to 'tablet-landscape'
                // on tablets (in landscape mode) this dfp iframe was being dropped on the page with a width of 1280px, but the width of the tablet is only 1024px
                // which made the page side-scrollable on tablets. To change the inline dimensions of the iframe you need to update width and height in dfpCopy.json (static repo)
                // and have someone change the dimensions in the dfp console
                // todo: figure out how to avoid not dropping the ad on desktops smaller than 1024px across.
                if ($('.doubleclick-container-nav').length && !$.cookie('dbl') && $win.width() > responsiveTargs['tablet-landscape']) {
                    dfp.addDfpCopy('1stdibsNavBanner', pageTarget);
                }
                if ($('.header-shipping-message-container').length) {
                    dfp.addDfpCopy('HeaderMessage');

                    $.subscribe('page:updated', function () {
                        dfp.refresh('HeaderMessage');
                    });
                }
            }

            dfp.fire();
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/nav/dfp.js
// module id = 2561
// module chunks = 62